import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useBooleanState } from '@cian/react-utils';

import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { AdBannerWrapper } from './components';
import { useTgbBetweenOffersParameters } from './hooks';

type TAdBannerMicrofrontendTgbBetweenOffersContainerProps = {
  manifest: IMicrofrontendManifest;
  position: number;
};

/**
 * Нативный TGB-баннер между офферами листинга ЖК на микрофронтенде ad-banner-frontend.
 */
export const AdBannerMicrofrontendTgbBetweenOffersContainer: React.FC<
  TAdBannerMicrofrontendTgbBetweenOffersContainerProps
> = ({ manifest, position }) => {
  const { state: isHidden, setTrue: hide } = useBooleanState();
  const parameters = useTgbBetweenOffersParameters(position);

  if (isHidden) {
    return null;
  }

  return (
    <AdBannerWrapper>
      <AdBannerMicrofrontendContainer
        manifest={manifest}
        parameters={parameters}
        onStub={hide}
        onError={hide}
        onClose={hide}
      />
    </AdBannerWrapper>
  );
};
